export const moduleName = 'reports';

export const reportsTabs = Object.freeze({
  BASIC: 'basic',
  HISTORY: 'history',
  COUNCIL: 'council',
  CUSTOM: 'custom',
} as const);

export type ReportsTabValues = (typeof reportsTabs)[keyof typeof reportsTabs];

export const reportTypes = Object.freeze({
  ADVANCEMENT_SUMMARY: 'advancementHistoryReport',
  ACTIVITIES_SUMMARY: 'activitiesSummaryReport',
  COUNCIL_ACTIVITIES_SUMMARY: 'councilActivitiesSummaryReport',
});
export type ReportTypes = keyof typeof reportTypes;

/**
 * This reports are UI generated and don't return report list
 */
export enum CustomReports {
  AdvancementReport = 'AdvancementReport',
  AdvancementHistory = 'AdvancementHistory',
  ActivitiesSummary = 'ActivitiesSummary',
  UnitRoster = 'UnitRosterReport',
}

// This code can be found in container or ReportCode on report uri params
export const reportCodes = Object.freeze({
  [CustomReports.AdvancementReport]: 'SBLAdvancementReport',
  [CustomReports.AdvancementHistory]: 'SBLUnitAdvancementSummary',
  [CustomReports.ActivitiesSummary]: 'SBLActivitiesSummaryReport',
  [CustomReports.UnitRoster]: 'SBLUnitRosterReport',
  REPORT_BUILDER_OUTPUT: 'SBReportBuilderOutput',
  ELIGIBILITY_REPORT: 'SBOAEligibilityReport',
  ACTIVITY_LOG: 'SBALActivityLogReport',
  MOST_RECENT_ACTIVITIES_UNIT: 'SBLMostRecentActivitiesSummaryReportByUnit',
  MOST_RECENT_ACTIVITIES: 'SBLMostRecentActivitiesSummaryReport',
  AUDIT_LOG: 'SBAuditLogReport',
  INDIVIDUAL_SCOUTS_BSA: 'SBBoyScoutIndividualRecord',
  CUB_SCOUT_HISTORY: 'SBCubScoutHistoryReport', // Note: this one has a by Den report which is not supported
  SCOUTS_BSA_HISTORY: 'SBSBSAHistoryReport',
  PACK_RECOGNITION: 'SBPackRecognitionReport',
  PAYMENT_LOG: 'SBPLPaymentLogReport',
  VENTURING_HISTORY: 'SBVHVenturingHistoryReport',
  TROOP_RECOGNITION: 'SBTroopRecognitionReport',
  SEA_SCOUT_HISTORY: 'SBSeaScoutHistoryReport',
  ACTIVITIES_SUMMARY: 'SBLActivitiesSummaryReport',
  COUNCIL_USERS: 'SBCouncilUsersReport',
  COUNCIL_ADVANCEMENT_REPORT_SCOUTS_BSA: 'OLRCouncilAdvancementReportScoutsBSA',
  COUNCIL_ADVANCEMENT_REPORT_CUB_SCOUTS: 'OLRCouncilAdvancementReportCubScouts',
  COUNCIL_ADVANCEMENT_REPORT_VENTURING: 'OLRCouncilAdvancementReportVenturing',
  COUNCIL_EAGLE_HOURS: 'SBLServiceHoursEagleScoutProjectByCouncilReport',
  ATTENDANCE: 'SBAttendanceReport',
  EAGLE_SCOUT_RANK_APPLICATION: 'SBEagleScoutRankApplication',
  TENTMATE: 'SBTentmateReport',
  IN_PROGRESS_MB: 'SBInProgressMBReport',
  UNIT_ROSTER_LITE: 'SBLUnitRosterLiteReport',
  SUMMIT_APPLICATION: 'SBL_SummitApplication',
  QUATERMASTER_AWARD_APPLICATION: 'SBL_QuatermasterAwardApplication',
  ROSTER_BUILDER_ADULTS: 'SBRosterBuilderReport',
  ROSTER_BUILDER_YOUTHS: 'SBRosterBuilderReport',
  SCOUTS_BSA_INDIVIDUAL_ADVANCEMENT: 'SBIARReport',
  COUNSELORS_IN_OTHER_COUNCILS: 'SBLCounselorsRegisteredInOtherCouncils',
  YPT_AGING_REPORT: 'YPTAgingReport',
  TRAINED_LEADER_STATUS: 'TrainedLeaderStatus',
  CUB_HISTORY_BY_MEMBER_ID: 'SBCubScoutHistoryReport_ByMemberID',
  SCOUT_HISTORY_BY_MEMBER_ID: 'SBSBSAHistoryReport_ByMemberID',
  EAGLE_SCOUT_BY_MEMBER_ID: 'SBEagleScoutRankApplication_ByMemberID',
  ACTIVITY_LOG_BY_MEMBER_ID: 'SBALActivityLogReport_ByMemberID',
  SUMMIT_APPLICATION_BY_MEMBER_ID: 'SBL_SummitApplication_ByMemberID',
  QUATERMASTER_AWARD_APPLICATION_BY_MEMBER_ID:
    'SBL_QuatermasterAwardApplication_ByMemberID',
});

export type ReportCodes = (typeof reportCodes)[keyof typeof reportCodes];

/** User by the adv. history report to create a context token */
export const ADV_HISTORY_CTX_API = `/advancements/webscript/output/sbreports.aspx?Application=MYST&Method=ExecuteScriptSet&ScriptCode=SaveScoutSelection`;

export const API_PO_ADV_REPORT = `/advancements/webscript/output/sbreports.aspx?Method=ExecuteContainerAPI&Container=SBAdvancementStoryReport&API=PrintEditablePDF`;

export const NEW_ROSTER_REPORT = `/vim2/webscript/output/proxy.aspx?method=ExecuteContainerAPI&container=SBRosterBuilderDesigner&api=ReportPresentation`;

export const NEW_PROGRESS_REPORT = `/vim2/webscript/output/proxy.aspx?method=ExecuteContainerAPI&container=SBReportBuilderDesigner&api=ReportPresentation`;
